import React, { Component, Fragment } from 'react';
import withErrorCatcher from '../../components/Common/withErrorCatcher.js'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { withStyles, Select, MenuItem } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { showSnackbar } from '../../../actions/appActions'
import i18n from 'i18next';
import moment from "moment"
import { withTranslation } from 'react-i18next';
import { FilePond, registerPlugin } from 'react-filepond';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';
import 'filepond/dist/filepond.min.css';
import DatePicker from '../../components/Header/SubheaderToolbar/Filters/DatePicker.js';
import PhoneInput from '../../components/Common/Text/PhoneInput.js';
import { updateUserProfile } from '../../../actions/userAction.js';
import { parseImageUrl } from '@tuqqi/common';
import {Signature} from './signature'
import { dataUrlToFile, FileToUri } from '../../../utils/base64ToFile.js';
import { withMixpanel } from '../../components/Common/withMixpanel.js';
registerPlugin(FilePondPluginImagePreview)

// Apply some reset
const styles = theme => ({
    imageLabel: {
        "display": "block",
        "color": "rgba(0, 0, 0, 0.54)",
        "padding": "0px",
        "fontSize": "1rem",
        "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
        "lineHeight": "1",
        "transform": "translate(0, 1.5px) scale(0.75)",
        "transformOrigin": "top left",
        "margin": "6px 0 3px"
    },
    datePicker: {
        margin: 0,
        width: '100%'
    }

});



class UserEditModal extends Component {

    state = {
        personalFeedSwitchDisable: false,

        // dialog
        open: false,
        firstname: undefined,
        lastname: undefined,
        title: undefined,
        isFeedPersonalized: false,
        profileImageUrl: undefined,
        lang: 'en-US',
        preLang: '',
        suggestedNews: '',
        signature: undefined,
        isEditSignature: false
    };

    fixImage(cloudfront, user) {

        var parse = parseImageUrl(cloudfront);

        if (user && user.profileImageUrl) {
            user.profileImageUrl = parse(user.profileImageUrl)
        }
        if (user && user.signature) {
            user.signature = parse(user.signature)
        }
    }
    getFixedSignature = (signature) => {
        var parse = parseImageUrl(this.props.cloudfront);
        const s = signature ? signature : ''
        return parse(s)
    }
    shouldUpdateSignature = () => {
        return this.state.signature && this.getFixedSignature(this.props.user.signature) !== this.getFixedSignature(this.state.signature) 
    }
    // dialog
    handleClickOpen = () => {
        const { user } = this.props

        this.setState({
            firstname: user.firstname,
            lastname: user.lastname,
            suggestedNews: user.suggestedNews || '',
            title: user.title,
            profileImageUrl: user.profileImageUrl,
            lang: user.lang || this.defaultLang,
            preLang: user.lang || this.defaultLang,
            bio: user.bio,
            birthday: user.birthday,
            phone: user.phone,
            homeAddress: user.homeAddress,
            officeAddress: user.officeAddress,
            nickname: user.nickname,
            open: true,
            signature: user.signature
        })
    };

    defaultLang = 'en-US'

    handleClose = () => {
        this.setState({ open: false });
        this.props.handleClose()
    };

    handleClickSave = async () => {
        const { userSettingsService, dispatch, cloudfront, t } = this.props;

        dispatch(showSnackbar(t('Saving')));
        const lang = this.state.lang || this.defaultLang

        const newData = {
            firstname: this.state.firstname,
            lastname: this.state.lastname,
            suggestedNews: this.state.suggestedNews,
            title: this.state.title,
            profileImageUrl: this.state.profileImageUrl,
            lang: this.state.lang,
            bio: encodeURIComponent(this.state.bio),
            birthday: this.state.birthday,
            phone: this.state.phone,
            homeAddress: this.state.homeAddress,
            officeAddress: this.state.officeAddress,
            nickname: this.state.nickname,
            signature: this.state.signature
        }
        if(this.shouldUpdateSignature()) {
            const {inputService} = this.props
            const file = await dataUrlToFile(this.state.signature, this.props.userData.profileData.auth0_id + '_signature', 'image/png')
            const uri = FileToUri(file)
            const response = await inputService.uploadMediaAsync(uri, this.props.userData.profileData.auth0_id + '_signature' + new Date().getTime(), 'image/png')
            newData.signature = response.link
        }
        userSettingsService.editUserSetting(newData)
            .then((res) => {
                if (!res.ok) {
                    dispatch(showSnackbar(t('Error occured while try to saving your change')));
                } else {

                    if (this.state.preLang != lang) {
                        i18n.changeLanguage(lang)
                        moment.locale(lang)
                    }
                    if(!!this.props.newuiProfile) {
                        dispatch({
                            type: 'USER_DETAILS_REQUEST_SUCCESS',
                            result: {...this.props.newuiProfile, lang}
                        })
                        dispatch({
                            type: 'UPDATE_USER_BY_UID',
                            auth0_id: this.props.newuiProfile.auth0_id,
                            result: {...this.props.newuiProfile, lang, ...newData}
                        })
                    }
                    this.fixImage(cloudfront, newData)
                    dispatch(updateUserProfile(newData));

                    dispatch(showSnackbar(t('Saved!')));
                    this.handleClose()
                }

            })
    }

    onChange = (name, newValue) => {
        this.setState({ [name]: newValue });
    }

    removeInvalidName = (name) => {
        return name.replace(/[^a-z]/gi, "")
    }

    onLoadImg = (res) => {
        const file = JSON.parse(res);
        this.onChange("profileImageUrl", file.link)
    }
    updateSignature = (signature) => {
        
        this.setState({signature})
        this.props.mixpanelTrack('User settings  - update signature', {});
    }
    setIsEditSignature = (isEditSignature) => {
        this.setState({isEditSignature})
    }

    uploadImg() {
        return <FilePond allowMultiple='false'
            labelIdle={this.props.t("filesUploader:d&dLabel")}

            server={
                {
                    url: process.env.API_SERVER + '/files/s3',
                    revert: null,
                    restore: null,
                    load: null,
                    fetch: null,
                    process: {
                        headers: {
                            'Authorization': 'Bearer ' + this.props.userData.idToken,
                        },
                        onload: this.onLoadImg
                    }
                }
            }
        />
    }

    langOptions = [
        { value: "en-US", label: 'English' },
        { value: "he-IL", label: 'עברית' },
        { value: "es-AR", label: 'Español' },        
        { value: "pl", label: 'Polski' },
        { value: "de", label: 'Deutsch' },
        { value: "pt-BR", label: 'Português' },
        { value: "ru", label: 'русский' },
        { value: "fr", label: 'Français' },
        {value : 'uk-UA', label: 'Українська'},
    ]

    onChangeName = (name) => (event) => {
        this.setState({ [name]: event.target.value });
    }

    handleTextFieldChange = (field) => (event) => {
        this.setState({ [field]: event.target.value });
    }

    render() {
        const { classes, t } = this.props;

        return (
            <Fragment>
                <Button onClick={this.handleClickOpen}
                    aria-label="edit"
                    color="primary"
                    variant={'raised'}>
                    {t('Edit Profile')}

                </Button>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">
                        {t('Edit Profile')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {t('To edit your profile, please enter your details here We will send updates occationally')}

                        </DialogContentText>

                        <TextField
                            autoFocus
                            margin="dense"
                            value={this.state.firstname}
                            label={t('First Name')}
                            fullWidth
                            onChange={this.onChangeName('firstname')} />
                        <TextField
                            margin="dense"
                            value={this.state.lastname}
                            label={t("Last Name")}
                            fullWidth
                            onChange={this.onChangeName('lastname')} />

                        <TextField
                            margin="dense"
                            value={this.state.title}
                            label={t('Title')}
                            fullWidth
                            onChange={this.handleTextFieldChange('title')} />

                        <TextField
                            margin="dense"
                            value={this.state.suggestedNews}
                            label={t("Suggested News")}
                            fullWidth
                            onChange={this.handleTextFieldChange('suggestedNews')} />

                        <TextField
                            fullWidth
                            // label={}
                            select
                            label={t("Select language")}
                            value={this.state.lang}
                            onChange={this.handleTextFieldChange('lang')}
                            margin="dense"
                        >
                            {this.langOptions.map(option => <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>)}
                        </TextField>
                        <TextField
                            margin="dense"
                            multiline
                            fullWidth
                            value={this.state.bio}
                            label={t("Bio")}
                            onChange={this.handleTextFieldChange('bio')} />
                        <DatePicker
                            classes={{ datePicker: classes.datePicker }}
                            selectedDate={this.state.birthday}
                            onChange={(date) => this.onChange("birthday", date)}
                            label={t("Birthday")} />
                        <PhoneInput
                            label={t("Phone Number")}
                            value={this.state.phone}
                            onChange={this.handleTextFieldChange('phone')} />
                        <TextField
                            margin="dense"
                            fullWidth
                            value={this.state.homeAddress}
                            label={t("Home address")}
                            onChange={this.handleTextFieldChange('homeAddress')} />
                        <TextField
                            margin="dense"
                            fullWidth
                            value={this.state.officeAddress}
                            label={t("Office address")}
                            onChange={this.handleTextFieldChange('officeAddress')} />

                        <TextField
                            margin="dense"
                            fullWidth
                            value={this.state.nickname}
                            label={t("Nickname")}
                            onChange={this.handleTextFieldChange('nickname')} />
                        <p className={classes.imageLabel}>{t("Image")}</p>
                        {this.uploadImg()}
                        <p className={classes.imageLabel}>{t("Signature")}</p>
                        <Signature 
                            classes={classes} 
                            signature={this.state.signature} 
                            t={t} 
                            getFixedSignature={this.getFixedSignature}
                            isEditSignature={this.state.isEditSignature}
                            setIsEditSignature={this.setIsEditSignature}
                            updateSignature={this.updateSignature} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} aria-label="delete" className={classes.button}>
                            {t('Cancel')}
                        </Button>
                        <Button onClick={this.handleClickSave} aria-label="save" className={classes.button}>
                            {t('Save')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => ({
    cloudfront: state.globalData.cloudfront,

    userData: state.userData,
    newuiProfile: state.data.userData.userDetails.data,
    ...state.services
})

const mapDispatchToProps = dispatch => {
    return { dispatch: dispatch }
}

export default compose(withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps),
    withMixpanel,
    withTranslation('userEditModal'),
    withErrorCatcher())(UserEditModal);